import { getEncounterCharges } from '../../../../neb-api-client/src/services/encounter-charge';

export default async ({ charges = [], encounterId = '' } = {}) => {
  const encounterCharges = await getEncounterCharges(charges, encounterId);
  return { encounterCharges };
};
